import React from 'react';
import { Hamburger } from 'jbc-front/components/icons';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import styles from './SortableAllowanceItemTable.scss';
import { useTranslation } from 'react-i18next';

const SortableAllowanceItemRow = SortableElement(({ allowanceItem }) => (
  <tr className={styles.line}>
    <th className={styles.icon}>
      <Hamburger size={17} />
    </th>
    <th>{allowanceItem.name}</th>
    <td>{allowanceItem.unitTypeFormatedValue}</td>
    <td>{allowanceItem.payslipDisplayTypeFormatedValue}</td>
    <td>{allowanceItem.numberOfPayrollRulesGroups}</td>
  </tr>
));

const SortableAllowanceItemTable = SortableContainer(({ allowanceItems }) => {
  const { t } = useTranslation();
  return (
    <div className="l-overflow-scroll">
      <table className="m-table-item m-table-fixed">
        <thead>
          <tr>
            <th width={50} />
            <th width={300}>{t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.item_name')}</th>
            <th width={100}>{t('features.ClientAllowanceItems.components.AllowanceItemsTable.unit')}</th>
            <th width={250}>{t('features.ClientAllowanceItems.components.AllowanceItemsTable.show_in_payslip')}</th>
            <th width={170}>{t('features.ClientAllowanceItems.components.AllowanceItemsTable.applicable_payroll_rule_group')}</th>
          </tr>
        </thead>
        <tbody>
          {(!allowanceItems || allowanceItems.length === 0) && (
            <tr>
              <td colSpan={5}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
            </tr>
          )}
          {allowanceItems &&
            allowanceItems.map((allowanceItem, index) => (
              <SortableAllowanceItemRow key={allowanceItem.id} index={index} allowanceItem={allowanceItem} />
            ))}
        </tbody>
      </table>
    </div>
  );
});

export default SortableAllowanceItemTable;
